import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";

export default function AssignTenantDialog({ open, onOpenChange, target, tenantEmail, setTenantEmail, onSubmit }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none">
        <DialogHeader>
          <DialogTitle className="font-display">{t("ll_assign_tenant")} — {target?.name}</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-3">
          <Label className="font-mono-label text-[10px]">{t("ll_tenant_email")}</Label>
          <Input
            data-testid="tenant-email-input"
            type="email"
            required
            value={tenantEmail}
            onChange={(e) => setTenantEmail(e.target.value)}
            className="rounded-none"
            placeholder="tenant@example.com"
          />
          <div className="text-xs text-zinc-500">{t("ll_tenant_help")}</div>
          <DialogFooter>
            <Button type="submit" className="rounded-none bg-black hover:bg-zinc-800">
              {t("ll_assign_btn")}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
